import client from '@/http'

const loadAll = (context) => {
  context.commit('SET_LOADING', 1)

  client.get(
    '/bundles'
  ).then(
    (res) => {
      context.commit('SET_BUNDLES', res.data)
      context.commit('SET_LOADING', 9)
    }
  ).catch(
    (err) => {
      console.error(err)
      context.commit('SET_LOADING', 8)
    }
  )
}

const load = (context, bundleId) => {
  client.get(
    `/bundles/${bundleId}`
  ).then(
    (res) => {
      context.commit('SET_BUNDLE', res.data)

      if (res.data.dossier_nr) {
        context.dispatch('dossiers/find', { nr: res.data.dossier_nr }, { root: true })
      }
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

const save = (context, params) => {
  const data = {
    name: params.name,
    dossier_nr: params.dossierNr,
    profile_nr: params.profileNr,
    has_disabled: params.hasDisabled
  }

  if (context.state.bundle !== null) {
    client.put(
      `/bundles/${context.state.bundle.id}`, data
    ).then(
      () => {
        context.commit('UPDATE', data)
      }
    ).catch(
      (err) => {
        console.error(err)
      }
    )
  } else {
    client.post(
      '/bundles', data
    ).then(
      (res) => {
        context.commit('PUSH', res.data)
      }
    ).catch(
      (err) => {
        console.error(err)
      }
    )
  }
}

const remove = (context, bundleId) => {
  client.delete(
    `bundles/${bundleId}`
  ).then(
    () => {
      context.commit('REMOVE', bundleId)
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

const duplicate = (context, params) => {
  client.post(
    'bundles/duplicate',
    params
  ).then(
    (res) => {
      context.commit(
        'PUSH',
        res.data
      )
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

export default {
  save,
  load,
  remove,
  loadAll,
  duplicate
}
